{
  "app_name": "SKILLMAP",
  "tagline": "Cartographie des compétences",
  "bp_level_placeholder": "Non défini",
  "logout": "Déconnexion",
  "no_data": "Aucune donnée disponible",
  "coming_soon_lot4": "Disponible après le lot campagne / analytics",
  "nav_dashboard": "Tableau de bord",
  "nav_assessment": "Mon Auto-évaluation",
  "nav_bpml": "BPML",
  "nav_analytics": "Analytiques",
  "nav_admin": "Administration",
  "nav_export": "Export",
  "nav_notifications": "Notifications",
  "nav_audit": "Journal d'audit",
  "nav_profile": "Mon Profil",
  "validation_dashboard": "Tableau de validation",
  "pending_submissions": "Sessions soumises à valider ou consulter",
  "validate": "Valider",
  "return_to_expert": "Renvoyer à l'expert",
  "force_validate": "Forcer la validation",
  "confirm_force_validate": "Forcer la validation ? Saisissez une raison obligatoire.",
  "mandatory_comment": "Commentaire obligatoire pour l'expert.",
  "comment": "Commentaire",
  "reason": "Raison",
  "cancel": "Annuler",
  "review": "Examiner",
  "open": "Ouvrir",
  "status": "Statut",
  "all": "Tous",
  "submission_date": "Date de soumission",
  "validate_failed": "Validation impossible",
  "return_failed": "Retour impossible",
  "user_management": "Gestion des utilisateurs",
  "import_users": "Import utilisateurs",
  "referentials": "Référentiels",
  "erp_scale": "Application & échelle",
  "bpml_import": "Import BPML",
  "bpml_enrichment": "Enrichissement BPML",
  "transversal_skills": "Compétences transversales",
  "transversal_shared_hint": "Les compétences transversales ne dépendent d’aucun domaine : une seule évaluation par an, une seule soumission.",
  "feature_self_eval": "Niveau de maîtrise — Fonctionnalités applicatives",
  "feature_self_eval_sub": "Évaluez votre niveau de maîtrise sur chaque fonctionnalité applicative de cette session. Ces scores sont partagés entre toutes vos sessions de l’année.",
  "no_feature_lines": "Aucune fonctionnalité applicative associée à cette session",
  "heat_map": "Heat Map",
  "radar_chart": "Radar",
  "gap_analysis": "Analyse des écarts",
  "individual_progression": "Progression individuelle",
  "team_coverage": "Couverture équipe",
  "training_needs": "Besoins de formation",
  "distribution": "Distribution",
  "transversal_team": "Équipe transversale",
  "role_admin": "Administrateur",
  "role_manager": "Responsable de domaine",
  "role_expert": "Expert",
  "status_draft": "Brouillon",
  "status_submitted": "Soumis",
  "status_validated": "Validé",
  "assessments": "Auto-évaluations",
  "new_assessment": "Nouvelle auto-évaluation",
  "save_draft": "Enregistrer brouillon",
  "submit_assessment": "Soumettre l'évaluation",
  "lines_scored": "lignes notées",
  "add_comment": "Ajouter un commentaire",
  "back_to_list": "Liste",
  "loading": "Chargement…",
  "confirm_submit": "Soumettre cette auto-évaluation ? Les scores ne seront plus modifiables.",
  "delete_draft": "Supprimer le brouillon",
  "confirm_delete_draft": "Supprimer ce brouillon ? L’expert pourra en recréer un sur la BPML active. Les notes de ce brouillon seront perdues (les scores transversaux de l’année sont conservés).",
  "delete_draft_failed": "Suppression impossible",
  "read_only_owner": "Lecture seule (vous n’êtes pas le propriétaire).",
  "full_name": "Nom complet",
  "domain": "Domaine",
  "erp": "Application",
  "year": "Année",
  "active": "Actif",
  "inactive": "Inactif",
  "user_id": "ID utilisateur",
  "select_user": "Utilisateur",
  "no_users_found": "Aucun utilisateur disponible",
  "progression_hint": "La courbe utilise les sessions soumises ou validées, par année et macro-processus.",
  "progression_select_hint": "Sélectionnez un utilisateur pour afficher sa progression.",
  "progression_empty_hint": "Aucune donnée de progression pour {{name}}. Il faut au moins une session soumise ou validée.",
  "target_threshold": "Seuil cible",
  "complexity_index": "Indice de complexité",
  "gap": "Écart",
  "gaps_none": "Toutes les lignes atteignent le seuil cible",
  "above_target": "Au-dessus du seuil",
  "critical": "Critique",
  "spof_risk": "SPOF",
  "weight_by_ci": "Pondérer par l'indice de complexité",
  "cumulative_gap": "Écart cumulé",
  "training_none": "Aucun besoin de formation identifié",
  "functional_skills": "Compétences fonctionnelles",
  "business_processes": "processus métier",
  "sub_processes": "sous-processus",
  "radar_axes_business": "compétences (agrégé)",
  "radar_zoom": "Zoom / détail",
  "radar_zoom_aggregated": "Vue agrégée (ex. Power BI)",
  "radar_zoom_back": "Revenir à l'agrégé",
  "radar_zoom_up": "Remonter d'un cran",
  "radar_drill_hint": "Descendre d'un cran là où il y a plusieurs sous-items :",
  "radar_grain_macro": "macro-processus",
  "radar_grain_task": "tâches",
  "categories": "catégories",
  "avg_score": "Score moyen",
  "score_count": "Nombre de scores",
  "analytics_load_failed": "Chargement analytics impossible",
  "analytics_hub": "Synthèse analytics",
  "analytics_hub_sub": "Risques & campagne — déplier les sections au besoin",
  "insight_critical_ie": "Process critiques — Interne vs Externe",
  "insight_spof": "SPOF / non couverts (critiques)",
  "insight_campaign": "Avancement campagne",
  "insight_more_views": "Vues détaillées & catalogue",
  "workforce_internal": "Internes ≥ seuil",
  "workforce_external": "Externes ≥ seuil",
  "only_external": "Externes seuls",
  "uncovered": "Non couvert",
  "spof_none": "Aucun SPOF / non couvert critique",
  "analytics_catalog_hint": "Catalogue restant : heatmap criticité×CI, multi-application, densité commentaires…",
  "domain_bench": "Bench domaine",
  "domain_bench_sub": "Moyenne des scores et % de cellules au seuil par domaine",
  "plaque_view": "Plaque / pays",
  "plaque_view_sub": "Répartition des experts et scores par plaque géographique et pays",
  "rare_expertise": "Expertise rare",
  "rare_expertise_sub": "Lignes BPML avec seulement 1 ou 2 experts au seuil (les lignes à 0 restent hors de cette vue)",
  "feature_heatmap": "Heatmap fonctionnalités",
  "feature_heatmap_title": "Heatmap compétences applicatives",
  "feature_heatmap_sub": "Grille experts × fonctionnalités applicatives (depuis Mes compétences applicatives)",
  "all_modules": "Tous les modules",
  "module": "Module (N1)",
  "avg": "Moy",
  "coverage_pct": "Couv.",
  "no_module": "Sans module",
  "no_submodule": "Sans sous-module",
  "feature_gap": "Analyse des gaps applicatifs",
  "feature_gap_title": "Analyse des gaps applicatifs",
  "feature_gap_sub": "Croise les besoins BPML (features enrichies) avec les compétences applicatives de l'équipe pour identifier les risques.",
  "bpml_lines_col": "Lignes BPML",
  "critical_lines_col": "Critiques",
  "experts_above_col": "Experts ≥ seuil",
  "avg_score_col": "Score moy.",
  "concerned_processes_col": "Processus concernés",
  "risk_filter": "Filtre risque",
  "all_risks": "Tous les risques",
  "all_domains": "Tous les domaines",
  "total_features_needed": "Features requises",
  "team_size": "Taille équipe",
  "uncovered_features": "features sans expert au-dessus du seuil",
  "no_results_for_filter": "Aucune feature ne correspond au filtre.",
  "pct_at_threshold": "% ≥ seuil",
  "experts": "Experts",
  "by_plaque": "Par plaque",
  "by_country": "Par pays",
  "experts_by_plaque": "Effectifs par plaque",
  "plaque": "Plaque",
  "country": "Pays",
  "plaque_manager_hint": "Scores masqués si moins de {{min}} experts (k-anonymat)",
  "plaque_countries_admin_only": "Le détail par pays est réservé aux Administrateurs.",
  "rare_single": "1 expert",
  "rare_two": "2 experts",
  "rare_none": "Aucune expertise rare dans le périmètre",
  "campaigns": "Campagnes",
  "campaigns_sub": "Suivi par domaine : statut, avancement, calendrier",
  "campaign_tab_board": "Tableau de bord",
  "campaign_tab_template": "Modèle annuel",
  "campaign_tab_suivi": "Suivi des statuts",
  "campaign_tab_calendar": "Calendrier & actions",
  "campaign_create_all": "Créer les campagnes pour tous les domaines",
  "campaign_create_all_hint": "Crée les campagnes manquantes et réapplique le modèle aux campagnes non utilisées (brouillon ou préparation, sans saisie). Les campagnes ouvertes ou déjà utilisées sont ignorées. Un modèle annuel enregistré est obligatoire.",
  "campaign_create_all_confirm_update": "Réappliquer le modèle aux {{count}} campagne(s) non utilisée(s) ({{domains}}) ? Les campagnes ouvertes ou déjà utilisées ne seront pas modifiées.",
  "campaign_generate_need_template": "Enregistrez d’abord le modèle annuel pour {{year}} (onglet Modèle annuel) avant de créer ou régénérer les campagnes.",
  "campaign_missing_domains": "{{count}} domaine(s) actif(s) sans campagne pour {{year}}.",
  "campaign_generate_done": "Génération terminée — créées : {{created}} · mises à jour : {{updated}} · ignorées : {{skipped}}",
  "campaign_none_year": "Aucune campagne pour cette année.",
  "campaign_suivi_title": "Suivi des campagnes",
  "campaign_suivi_hint": "Statut de chaque domaine et avancement des auto-évaluations (brouillon + soumis = en cours, validé = validés).",
  "campaign_suivi_process_section": "Auto-évaluations process (BPML)",
  "campaign_suivi_transversal_section": "Auto-évaluations transversales (comptées par domaine de rattachement de l'expert)",
  "campaign_suivi_col_in_progress": "En cours",
  "campaign_suivi_col_validated": "Validés",
  "campaign_suivi_col_total": "Total sessions",
  "campaign_suivi_col_campaign_status": "Campagne",
  "campaign_suivi_features_section": "Suivi features applicatives",
  "campaign_suivi_features_hint": "Pour chaque domaine (de rattachement, cf. règle lot 3) et chaque application, nombre d'experts dont la grille de features est complète (toutes les features actives scorées) sur le total d'experts rattachés au domaine.",
  "campaign_suivi_col_experts": "Experts",
  "campaign_suivi_features_missing_badge": "Features manquantes",
  "campaign_suivi_features_missing_hint": "Cette application active n'a aucune fonctionnalité active définie : la complétude affichée est automatique (0/0) et ne reflète pas une vraie auto-évaluation.",
  "dashboard_title": "Tableau de bord",
  "dashboard_subtitle": "Vue d'ensemble des campagnes en cours — cliquez sur une carte pour le détail.",
  "dashboard_kpi_pending_validations": "Validations en attente",
  "dashboard_kpi_pending_validations_detail": "{{process}} process · {{transversal}} transversal",
  "dashboard_kpi_process": "Process — validés",
  "dashboard_kpi_process_detail": "{{inProgress}} en cours · {{validated}} validés sur {{total}}",
  "dashboard_kpi_transversal": "Transversal — validés",
  "dashboard_kpi_transversal_detail": "{{inProgress}} en cours · {{validated}} validés sur {{total}}",
  "dashboard_kpi_features": "Features applicatives — renseignées",
  "dashboard_kpi_features_detail": "{{completed}}/{{total}} grilles complètes",
  "dashboard_detail_hint": "Pour le détail par domaine, voir l'onglet",
  "campaign_banner": "Campagne {{domain}} {{year}} ({{status}})",
  "campaign_deadline": "soumission avant le {{date}}",
  "campaign_step_end_before_start": "La date de fin de « {{step}} » doit être le même jour ou après la date de début.",
  "campaign_template_date_hint": "Pour chaque étape, la fin doit être le même jour ou après le début. Fin d’étape → début suivante = lendemain (si vide).",
  "preevals": "Préévaluations",
  "preevals_sub": "Vision Manager des compétences (hors scores Expert) — étape optionnelle de campagne",
  "new_preeval": "Nouvelle prééval",
  "new_preeval_sub": "Choisissez l’expert, le domaine, l’ERP et l’année. Les scores restent invisibles pour l’expert.",
  "create_and_score": "Créer et noter",
  "preeval_gaps": "Écarts Expert / Manager",
  "preeval_gaps_sub": "Comparaison après auto-évaluation Expert : delta = score Expert − score Manager",
  "preeval_gaps_only_diff": "Écarts non nuls seulement",
  "preeval_gaps_formula": "Δ positif = Expert plus haut que le Manager ; Δ négatif = Expert plus bas.",
  "preeval_for": "Prééval pour",
  "preeval_privacy_hint": "Ces notes restent côté Manager/Admin — l’expert ne les voit jamais.",
  "submit_preeval": "Soumettre la prééval",
  "confirm_submit_preeval": "Soumettre cette préévaluation ? Elle passera en lecture seule.",
  "confirm_submit_preeval_empty": "Aucun score saisi. Soumettre quand même (lecture seule) ?",
  "preeval_gaps_empty": "Aucune prééval Manager avec scores pour ces filtres — ou l’expert n’a pas encore soumis son auto-éval.",
  "preeval_gaps_no_diff": "Aucun écart non nul (décochez « écarts non nuls » pour tout voir).",
  "preeval_pending": "restantes",
  "preeval_complete": "toutes notées",
  "preeval_filter_pending": "Non notées",
  "preeval_score_hint": "Cliquez un score pour noter ; recliquez pour effacer. Ligne verte = déjà saisie.",
  "preeval_not_scored": "Non noté",
  "preeval_line_scored": "Noté : {{score}}",
  "preeval_line_pending": "À noter",
  "preeval_progress_col": "Avancement saisie",
  "preeval_fill_none": "Non démarrée",
  "preeval_fill_partial": "En cours",
  "preeval_fill_full": "Complète",
  "preeval_continue": "Continuer",
  "preeval_tv_shared_hint": "Transversales : une seule vision Manager par expert et par année — partagée si l’expert a plusieurs domaines / ERP (comme l’auto-éval Expert).",
  "save": "Enregistrer",
  "preeval_scale_legend": "Échelle de scores",
  "preeval_compare": "Comparer avec l’auto-éval",
  "preeval_compare_ready": "Auto-éval Expert disponible ({{status}}). Écarts ligne à ligne ci-dessous (Expert vs votre note).",
  "preeval_compare_waiting": "Comparaison disponible dès que l’expert a soumis (ou validé) son auto-éval pour ce domaine / ERP / année.",
  "preeval_open_assessment": "Ouvrir l’auto-éval",
  "preeval_filter_gaps": "Écarts",
  "preeval_expert_short": "Expert",
  "preeval_expert_na": "Expert —",
  "preeval_compare_hint": "Δ = score Expert − votre score Manager",
  "export_sub": "Export Excel asynchrone des scores (BPML + Transversales) — téléchargement dès que prêt",
  "export_new": "Nouvelle demande",
  "export_hint": "Deux onglets : BPML et Transversal. Génération en quelques secondes ; le fichier reste téléchargeable ~24 h. Un e-mail est envoyé quand l’export est prêt (ou en échec).",
  "export_start": "Lancer l’export",
  "export_jobs": "Mes exports",
  "export_created": "Demandé le",
  "export_download": "Télécharger",
  "export_wait": "En cours…",
  "export_status_filter": "Sessions incluses",
  "export_status_submitted_validated": "Soumises + validées",
  "export_status_validated_only": "Validées uniquement",
  "export_status_queued": "En file",
  "export_status_running": "En cours",
  "export_status_ready": "Prêt",
  "export_status_failed": "Échec",
  "export_load_failed": "Impossible de charger les exports",
  "export_request_failed": "Demande d’export impossible",
  "export_download_failed": "Téléchargement impossible",
  "notif_sub": "Rappels d’échéance et journal d’envois e-mail (SMTP / log DEV)",
  "notif_offsets": "Décalages de rappel",
  "notif_offsets_hint": "Jours avant l’échéance SUBMIT_DEADLINE des campagnes ouvertes (ex. 14, 3, 0 = J-14, J-3, jour J). Fuseau Europe/Paris.",
  "notif_offsets_label": "Offsets (jours, séparés par des virgules)",
  "notif_mail_mode": "Mode envoi",
  "notif_last_run": "Dernière passe",
  "notif_run_now": "Lancer les rappels maintenant",
  "notif_recent": "Envois récents",
  "notif_type": "Type",
  "notif_recipient": "Destinataire",
  "notif_sent_at": "Envoyé le",
  "notif_load_failed": "Impossible de charger la config notifications",
  "notif_save_failed": "Enregistrement impossible",
  "notif_saved": "Décalages enregistrés",
  "notif_run_failed": "Exécution des rappels impossible",
  "notif_run_result": "Rappels : {{sent}} envoyé(s), {{skipped}} ignoré(s), {{failed}} échec(s) — {{candidates}} candidat(s)",
  "assessments_sub": "Sessions par domaine, application (optionnel) et année.",
  "assessments_load_failed": "Impossible de charger les auto-évaluations",
  "scores_progress": "Scores",
  "audit_sub": "Événements append-only avec détail des changements — Admin uniquement",
  "audit_search": "Recherche",
  "audit_search_ph": "Action, acteur, cible…",
  "audit_action": "Action",
  "audit_from": "Du",
  "audit_to": "Au",
  "audit_when": "Date",
  "audit_actor": "Acteur",
  "audit_target": "Cible",
  "audit_details": "Modifications",
  "audit_total": "{{total}} événement(s)",
  "audit_prev": "Précédent",
  "audit_next": "Suivant",
  "audit_page": "Page {{page}} / {{totalPages}}",
  "audit_load_failed": "Impossible de charger le journal d’audit",
  "load_failed": "Chargement impossible",
  "save_failed": "Enregistrement impossible",
  "create_failed": "Création impossible",
  "update_failed": "Mise à jour impossible",
  "download_failed": "Téléchargement impossible",
  "import_failed": "Import impossible",
  "activate_failed": "Activation impossible",
  "transition_failed": "Transition impossible",
  "generate_failed": "Génération impossible",
  "save_template_failed": "Enregistrement du modèle impossible",
  "sync_bpml_failed": "Synchronisation BPML impossible",
  "submit_failed": "Soumission impossible",
  "choose_xlsx": "Choisissez un fichier Excel (.xlsx).",
  "version_label_required": "Indiquez un libellé de version.",
  "yes": "Oui",
  "no": "Non",
  "filter": "Filtrer",
  "edit": "Éditer",
  "add": "Ajouter",
  "import": "Importer",
  "activate": "Activer",
  "deactivate": "Désactiver",
  "actions": "Actions",
  "code": "Code",
  "label_en": "Label EN",
  "label_fr": "Label FR",
  "matricule": "Matricule",
  "email_label": "E-mail",
  "role": "Rôle",
  "language": "Langue",
  "department": "Département",
  "population": "Population",
  "workforce": "Interne / Externe",
  "workforce_internal_opt": "Interne",
  "workforce_external_opt": "Externe",
  "coming_soon_body": "Écran prévu (réf. SkillMap V0). Disponible après le lot campagne / analytics.",
  "api_network_error": "Impossible de joindre l’API (réseau, CORS, ou délai dépassé). Sur DEV hébergé, l’import utilisateurs dépasse souvent 29s si le fichier a beaucoup de lignes — scindez le Excel.",
  "required_domain_erp": "Le domaine est obligatoire.",
  "required_expert_domain_erp": "L'expert et le domaine sont obligatoires.",
  "required_expert_domain": "L'expert et le domaine sont obligatoires.",
  "session_exists": "Session déjà existante — ouvrez-la depuis la liste.",
  "new_assessment_sub": "Choisissez domaine, application (optionnel) et année. Si une application est sélectionnée, seules les lignes BPML correspondantes sont préremplies ; sinon, toutes les lignes BPML sont incluses.",
  "complexity_short": "(Complex. : {{n}})",
  "bpml_line": "Ligne BPML",
  "self_assessment_short": "Auto-éval",
  "experts_not_found": "Experts introuvables",
  "load_lines_failed": "Chargement lignes impossible",
  "load_skills_failed": "Chargement skills impossible",
  "login_subtitle": "Skills vs BPML — Arkema IT",
  "login_api_unreachable": "Impossible de joindre l’API (login-config). Démarrez le backend (port 4000) puis rechargez.",
  "login_hint_fallback": "API login-config injoignable — mot de passe = SEED_DEV_PASSWORD / backend/.env.",
  "login_dev_hint_note": "Compte admin DEV — mot de passe dans SEED_DEV_PASSWORD / backend/.env (jamais exposé par l’API).",
  "login_dev_only": "DEV uniquement",
  "login_user": "Utilisateur :",
  "login_sso_body": "Cet environnement utilise l'authentification SSO (OIDC / Cognito). La connexion par mot de passe est désactivée.",
  "login_sso_soon": "Se connecter via SSO (bientôt)",
  "login_sso_title": "SSO à brancher (Phase 2)",
  "login_identifier": "E-mail ou matricule",
  "login_identifier_ph": "prenom.nom@arkema.com ou A6049046",
  "login_password": "Mot de passe",
  "login_show_password": "Afficher le mot de passe",
  "login_hide_password": "Masquer le mot de passe",
  "login_submit": "Se connecter",
  "login_submitting": "Connexion…",
  "login_footer": "En production : authentification SSO/OIDC Arkema — identifiant fourni automatiquement",
  "login_locked": "Compte temporairement verrouillé après trop d'échecs. Réessayez plus tard.",
  "login_sso_required": "Connexion par mot de passe désactivée. Utilisez le SSO.",
  "login_bad_credentials": "Identifiant ou mot de passe incorrect.",
  "login_connect_failed": "Impossible de se connecter. Vérifiez que le backend est démarré.",
  "campaign_step_BPML_READY": "BPML prête",
  "campaign_step_ENRICH": "Enrichissement",
  "campaign_step_PREEVAL": "Préévaluation (opt.)",
  "campaign_step_EXPERT_ENTRY": "Saisie experts",
  "campaign_step_SUBMIT_DEADLINE": "Deadline soumission",
  "campaign_step_VALIDATION": "Validation",
  "campaign_step_ANALYSIS": "Analyses",
  "campaign_status_draft": "Brouillon",
  "campaign_status_prep": "Préparation",
  "campaign_status_open": "Ouverte",
  "campaign_status_closed": "Clôturée",
  "campaign_phase_not_started": "Non démarré",
  "campaign_phase_in_progress": "En cours",
  "campaign_phase_blocked": "Bloquée",
  "campaign_phase_delayed": "En retard",
  "campaign_phase_done": "Terminé",
  "campaign_phase_skipped": "Ignoré",
  "campaign_board_phases": "Tableau de bord des phases",
  "campaign_board_hint": "Statut de chaque étape par domaine. Cliquez une cellule pour mettre à jour le statut et le commentaire.",
  "campaign_kpi_blocked": "Bloquées",
  "campaign_kpi_delayed": "En retard (statut)",
  "campaign_kpi_in_progress": "En cours",
  "campaign_kpi_overdue": "Échéance dépassée",
  "deadline": "Deadline",
  "comment_ph": "Commentaire…",
  "calendar": "Calendrier",
  "year_template_title": "Modèle annuel {{year}}",
  "campaign_template_manager_hint": "Le modèle de dates est géré par l'Administrateur. Vous pouvez consulter le calendrier de vos campagnes dans l'onglet Calendrier & actions.",
  "campaign_template_admin_hint": "Définissez une fois les dates de chaque étape pour l'année, puis générez les campagnes de tous les domaines (bouton ci-dessous ou en haut de page). Les campagnes peuvent aussi être créées sans dates : vous les renseignez ensuite ici ou dans Calendrier.",
  "step": "Étape",
  "starts_on": "Début",
  "ends_on": "Fin",
  "required_short": "Req.",
  "save_template": "Enregistrer le modèle",
  "template_last_update": "Dernière mise à jour du modèle",
  "select_campaign": "Sélectionnez une campagne.",
  "to_prep": "→ Préparation",
  "close_campaign": "Clôturer",
  "allow_manager_dates": "Autoriser le Manager à modifier les dates",
  "dates_readonly_admin": "Dates en lecture seule (Admin).",
  "campaign_open_hint": "Pour ouvrir : Deadline soumission + BPML active. Fin d'étape → début suivante = lendemain (si vide).",
  "preevals_manager_link": "Préévaluations Manager →",
  "preevals_optional_hint": "(étape optionnelle — scores hors auto-éval Expert)",
  "create_user": "Créer un utilisateur",
  "edit_user": "Modifier l'utilisateur",
  "search_users": "Recherche (matricule, email, nom)",
  "temp_password_once": "Mot de passe temporaire (à communiquer une seule fois) :",
  "password_optional": "Mot de passe (optionnel — sinon généré)",
  "account_active": "Compte actif",
  "reset_password": "Reset MDP",
  "reset_password_confirm": "Réinitialiser le mot de passe de {{id}} ?",
  "reset_password_prompt": "Nouveau mot de passe (min. 12 caractères) — laisser vide pour générer :",
  "reset_failed": "Réinitialisation impossible",
  "users_sub": "Comptes, rôles, domaines et mot de passe local",
  "manager": "Manager (N+1)",
  "matrix_managers": "Managers matriciels",
  "matrix_managers_hint": "Reports matriciels (lecture seule des résultats de l'expert).",
  "matrix_short": "matriciel(s)",
  "import_xlsx": "Import (.xlsx)",
  "back_users": "← Retour utilisateurs",
  "import_users_title": "Import utilisateurs (Excel)",
  "import_users_help": "Colonnes : internalId, email, fullName, role, population, language, country, domains, department. La colonne country (ISO alpha-2) est obligatoire. Valeurs role / population / language / country / domains / department : codes ou libellés du référentiel Admin — insensibles à la casse. Avec le modèle multi-onglets, les données sont lues dans l'onglet Donnees (pas Guide).",
  "download_excel_template": "Télécharger le modèle Excel",
  "import_in_progress": "Import en cours…",
  "report": "Rapport",
  "created_n": "Créés",
  "updated_n": "Mis à jour",
  "errors_n": "Erreurs",
  "excel_row": "Ligne Excel {{row}} :",
  "row_n": "Ligne {{row}} :",
  "referentials_sub": "Valeurs utilisées dans les formulaires et les imports Excel. Pays : plaque EMEA / AMAS / APOC / GC (CN = Greater China, hors APOC).",
  "ref_kind_departments": "Départements",
  "ref_kind_domains": "Domaines",
  "ref_kind_countries": "Pays",
  "ref_kind_roles": "Rôles",
  "ref_kind_populations": "Populations",
  "ref_kind_languages": "Langues",
  "import_excel_kind": "Import Excel — {{kind}}",
  "import_excel_templates": "Templates 01–06 (onglet Donnees). Upsert par code.",
  "no_entries": "Aucune entrée",
  "access_level": "Niveau accès",
  "system_entry_hint": "* entrée système (seed) — code non modifiable ; labels / plaque / statut oui",
  "edit_code": "Modifier — {{code}}",
  "add_kind": "Ajouter — {{kind}}",
  "code_immutable": "Le code ne peut pas être modifié",
  "parent_department": "Département parent (obligatoire)",
  "parent_department_opt": "— Département —",
  "geo_plaque": "Plaque géographique",
  "access_level_hint": "Niveau d'accès (100=admin, 50=manager, 10=expert)",
  "erp_scale_title": "Configuration Application & échelle",
  "erp_list": "Liste des applications",
  "environments_title": "Environnements applicatifs",
  "environments_desc": "Les environnements représentent des instances spécifiques d'une application (ex : NICE et BEST pour SAP). Les lignes BPML taguées génèrent une ligne d'assessment par environnement.",
  "new_environment_label": "Nom de l'environnement (ex : NICE)",
  "no_environments_yet": "Aucun environnement. Utilisez le formulaire ci-dessus pour en ajouter.",
  "select_application": "Application",
  "required_application": "Veuillez sélectionner une application",
  "erp_active": "actif",
  "erp_inactive": "inactif",
  "sort_order": "ordre",
  "new_erp": "Nouvelle application",
  "create_erp_failed": "Création application impossible",
  "update_erp_failed": "Mise à jour application impossible",
  "threshold_failed": "Seuil impossible",
  "skill_scale": "Échelle de compétence",
  "import_excel_erp": "Import Excel Applications",
  "import_excel_scale": "Import Excel échelle (08)",
  "import_excel_threshold": "Import Excel seuil (09)",
  "level": "Niveau",
  "active_from": "Actif depuis",
  "add_level": "Ajouter niveau",
  "current": "Courant",
  "undefined_value": "non défini",
  "set_on": "posé le",
  "save_threshold": "Enregistrer le seuil",
  "bpml_ref_title": "Référentiel BPML",
  "bpml_import_help": "Import Excel → nouvelle version (inactive). Colonnes SkillMap : domain, macroProcess, businessProcess, processCategory (+ subProcess, task, erpScope). Format corporate accepté. L’activation rend la version unique active. Modèle multi-onglets : données dans l’onglet Donnees (pas Guide).",
  "new_import": "Nouvel import",
  "version_label_ph": "Libellé version (ex. BPML 2026-Q3)",
  "import_ok": "Import OK — {{imported}} ligne(s), domaines {{domains}}. Carry-over enrichissement : {{carriedOver}}. Version créée inactive.",
  "versions": "Versions",
  "imported_on": "Importé le",
  "line_count": "Lignes",
  "status_active": "Active",
  "status_inactive": "Inactive",
  "enrichment_title": "Enrichissement BPML",
  "enrichment_help": "Version active uniquement. Éditez complexité, label, critique, périmètre applicatif et fonctionnalités ; ajoutez Sub / Task. Import bulk possible.",
  "critical_n": "{{count}} critique(s)",
  "critical_col": "Critique",
  "critical_hint": "Première colonne Critique : cochez pour marquer un processus critique (SPOF / continuité).",
  "no_critical_lines": "Aucune ligne critique — cochez Critique sur les processus concernés.",
  "reset_enrichment": "Réinitialiser l'enrichissement",
  "confirm_reset_enrichment": "Réinitialiser l'enrichissement de cette version ? Les sous-processus / tâches ajoutés et les flags critique seront perdus.",
  "add_child": "Ajouter un enfant",
  "tv_catalog_title": "Compétences transversales",
  "tv_include_archived": "Inclure archivées",
  "archive": "Archiver",
  "unarchive": "Désarchiver",
  "version_label": "Libellé",
  "confirm_activate": "Activer cette version ? La version active actuelle sera désactivée.",
  "import_ellipsis": "Import…",
  "erp_scope": "Périmètre applicatif",
  "label": "Libellé",
  "domains": "Domaines",
  "session_exists_id": "Session déjà existante — ouvrez-la depuis la liste ({{id}}…).",
  "select_domain_reset": "Sélectionnez un domaine à réinitialiser.",
  "select_parent_line": "Sélectionnez une ligne parent.",
  "enrich_import_merge_hint": "Même hiérarchie sur plusieurs lignes Excel avec des applications différentes → fusion automatique des périmètres sur une seule ligne BPML.",
  "parent_line_ph": "Ligne parent…",
  "task_optional": "Task (optionnel)",
  "critical_only": "Critiques uniquement",
  "application_scope": "Périmètre applicatif",
  "application_scope_ph": "App1, App2 (vide = tous)",
  "application_scope_hint": "Plusieurs applications séparées par virgule. Vide = applicable à toutes.",
  "erp_scope_ph": "App1, App2 (vide = tous)",
  "erp_scope_hint": "Plusieurs applications séparées par virgule. Vide = applicable à toutes.",
  "tv_macro_ph": "Macro / catégorie",
  "tv_bp_ph": "Business process",
  "tv_sub_ph": "Sub process",
  "tv_task_ph": "Task",
  "sub_process": "Sub Process",
  "application_features": "Fonctionnalités applicatives",
  "application_features_title": "Fonctionnalités applicatives",
  "application_features_sub": "Gérez les fonctionnalités spécifiques aux applications (transactions, modules) liées aux lignes BPML.",
  "new_feature": "Nouvelle fonctionnalité",
  "edit_feature": "Modifier la fonctionnalité",
  "feature_code": "Code",
  "feature_label": "Libellé",
  "feature_application": "Application",
  "feature_application_required": "Veuillez sélectionner une application pour cette fonctionnalité.",
  "create_feature_failed": "Création de fonctionnalité impossible",
  "update_feature_failed": "Mise à jour de fonctionnalité impossible",
  "import_excel_features": "Import fonctionnalités applicatives (Excel)",
  "features": "Fonctionnalités",
  "no_application": "Sans application (toute la BPML)",
  "application_optional": "Application (optionnel)",
  "application": "Application",
  "applications": "Applications",
  "environment": "Environnement",
  "environments": "Environnements",
  "nav_app_skills": "Mes compétences applicatives",
  "nav_transversal_skills": "Mes compétences transversales",
  "my_transversal_skills_title": "Mes compétences transversales",
  "my_transversal_skills_sub": "Auto-évaluez vos compétences transversales pour l'année. Une seule soumission, validée par votre manager.",
  "transversal_submission_status": "Soumission",
  "submit_needs_all_scored": "Toutes les compétences doivent être notées avant de soumettre.",
  "transversal_validation_title": "Validation transversale",
  "validation_kind_process": "Process (BPML)",
  "validation_kind_transversal": "Transversal",
  "my_application_skills_title": "Mes compétences applicatives",
  "my_application_skills_sub": "Auto-évaluez vos compétences sur les fonctionnalités applicatives. Les scores sont partagés entre tous vos assessments de l'année.",
  "select_application_hint": "Sélectionnez une application pour voir ses fonctionnalités.",
  "no_features_for_application": "Aucune fonctionnalité active trouvée pour cette application.",
  "saving": "Enregistrement…",
  "saved": "Enregistré",
  "unsaved_changes": "Modifications non enregistrées",
  "progress": "Progression",
  "all_applications": "Toutes les applications",
  "optional": "optionnel",
  "required_domain": "Le domaine est obligatoire.",
  "bulk_apply_button": "Appliquer à toutes les features vides",
  "bulk_apply_title": "Prérenseigner les features vides",
  "bulk_apply_score_label": "Niveau à appliquer",
  "bulk_apply_none_empty": "Toutes les features actives de cette application sont déjà renseignées.",
  "bulk_apply_confirm": "Appliquer le niveau {{score}} à toutes les features actuellement vides de cette application ? Les features déjà notées individuellement ne seront pas modifiées.",
  "bulk_apply_success": "{{count}} fonctionnalité(s) prérenseignée(s).",
  "bulk_apply_success_none": "Aucune fonctionnalité vide à prérenseigner (tout était déjà renseigné).",
  "bulk_apply_failed": "Échec de l'application en masse.",
  "bulk_apply_cancel": "Annuler"
}